
import { Component, Vue, Watch } from "vue-property-decorator";
import { customerOrderService } from "@/services/api/customerOrder.service";
import { CustomerOrderByIDRequest } from "@/models/entities/customerOrder/customerOrderRequest.interface";
import { getModule } from "vuex-module-decorators";
import store from "@/store";
// import OverlayModule from "@/store/modules/core/overlay.module";
import AuthModule from "@/store/modules/core/auth.module";
import { AdminUsers } from "@/models/utils/admin-users.interface";
const authModule = getModule(AuthModule, store);
// const overlayModule = getModule(OverlayModule, store);
const AppBar = () => import("@/components/core/AppBar.vue");
const LoadingOverlay = () => import("@/components/core/LoadingOverlay.vue");
const AppFooter = () => import("@/components/core/AppFooter.vue");
const MessageDialog = () => import("@/components/core/MessageDialog.vue");

@Component({
  components: {
    AppBar,
    AppFooter,
    LoadingOverlay,
    MessageDialog,
  },
})
export default class Orders extends Vue {
  // VARS --- NON-ADMIN REWORK
  private adminUsers = AdminUsers;
  private userName = "";

  // VARS --- COMPONENTS
  private numberSelected = 0;
  private messageDialogOpen = false;
  private dialogText = "";
  private loadingOverlayOpen = false;
  private isLoadingButton = false;

  // VARS --- DATEPICKER: END DATE
  private dateStartISO = new Date(
    Date.now() - new Date().getTimezoneOffset() * 60000
  )
    .toISOString()
    .substr(0, 10);
  private dateStart = new Date(
    Date.now() - new Date().getTimezoneOffset() * 60000
  )
    .toISOString()
    .substr(0, 10);
  private menuDateStart = false;

  // VARS --- DATEPICKER: END DATE
  private dateEndISO = new Date(
    Date.now() - new Date().getTimezoneOffset() * 60000
  )
    .toISOString()
    .substr(0, 10);
  private dateEnd = new Date(
    Date.now() - new Date().getTimezoneOffset() * 60000
  )
    .toISOString()
    .substr(0, 10);
  private menuDateEnd = false;

  private selectedOrderAmount = 0;
  private selectedOrderKits = 0;
  private simpleTableKey = false;

  private declare selectedOrder: {
    orderId: number;
    purchaseDateView: number;
    orderDate: string;
    codiceCliente: string;
    ragioneSociale: string;
    OrderDetails: CustomerOrderByIDRequest[];
  };
  private beforeCreate(): void {
    // if (authModule.role != "0") {
    //   this.$router.push("/");
    // }
  }
  beforeMount(): void {
    this.selectedOrder = {
      orderId: -1,
      purchaseDateView: Date.now(),
      orderDate: "",
      codiceCliente: "",
      ragioneSociale: "",
      OrderDetails: [],
    };
  }

  mounted(): void {
    // Init datepicker
    this.dateStart = this.formatDate(this.dateStartISO);
    this.dateEnd = this.formatDate(this.dateEndISO);
    // set username properly:
    this.userName = authModule.userName;
  }

  // DATEPICKER WATCHER
  @Watch("dateStartISO")
  dateStartChanged(): void {
    this.dateStart = this.formatDate(this.dateStartISO);
  }
  @Watch("dateEndISO")
  dateEndChanged(): void {
    this.dateEnd = this.formatDate(this.dateEndISO);
  }

  // VARS --- SEARCH QUERY
  private orderID = null;
  private checkNotCompleted = false;
  private checkNoEmail = false;

  // VARS --- TABLE
  private isLoading = false;
  private search = "";
  private headers = {
    auth: [
      {
        text: "ID Ordine",
        align: "start",
        filterable: true,
        value: "orderID",
      },
      { text: "Data ordine", value: "purchaseDateView" },
      { text: "Codice cliente", value: "codiceCliente" },
      { text: "Ragione sociale", value: "ragioneSociale" },
      { text: "Mail inviata", value: "mailHasSent", align: "center" },
      {
        text: "Azioni",
        value: "Actions",
        align: "center",
        class: "table_header__actions",
      },
    ],
    user: [
      {
        text: "ID Ordine",
        align: "start",
        filterable: true,
        value: "orderID",
      },
      { text: "Data ordine", value: "purchaseDateView" },
      {
        text: "Azioni",
        value: "Actions",
        align: "center",
        class: "table_header__actions",
      },
    ],
  };
  private set = [];

  // VARS --- EMAIL CONFIRMATION MODAL
  private dialogEmail = false;
  private emailItemToSend = {
    orderID: null,
    codiceCliente: "",
    ragioneSociale: "",
  };

  // VARS --- SELECTED ORDER DETAILS
  private dialogDetails = false;
  private dialogTableHeaders = [
    { text: "Codice", value: "productID" },
    {
      text: "Categoria",
      align: "start",
      filterable: true,
      value: "catDescr",
    },
    { text: "Descrizione", value: "description" },
    { text: "Chiavi Ricerca", value: "keywords" },
    { text: "Marca", value: "brand" },
    { text: "Modello Auto", value: "model" },
    { text: "Anno", value: "fromYear" },
    { text: "Tipo", value: "carType" },
    { text: "Canale", value: "artCanale" },
    { text: "Diam.", value: "diameter" },
    { text: "Fori", value: "artFori" },
    { text: "Pcd", value: "artPcd" },
    { text: "Foro centr.", value: "artForoCentrale" },
    { text: "Et", value: "artEt" },
    { text: "Peso", value: "peso" },
    { text: "Qty", value: "quantity" },
    { text: "P.N.", value: "price" },
    { text: "Tot.", value: "price" },
  ];

  // METHODS --- DATEPICKER FORMATTING
  private formatDate(date): string {
    if (!date) return null;
    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year}`;
  }
  private parseDate(date): string {
    if (!date) return null;
    const [day, month, year] = date.split("/");
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  }

  // METHODS --- REFRESH TABLE
  private refreshTable(): void {
    this.isLoading = true;
    if (this.adminUsers.includes(this.userName)) {
      // CASE ADMIN --- ALL ORDERS
      customerOrderService
        .getOrders(
          this.dateStart,
          this.dateEnd,
          this.orderID ? this.orderID : "",
          this.checkNotCompleted,
          this.checkNoEmail
        )
        .then((res) => {
          // Open state dialog
          if (res.status === 200) {
            this.set = res.data;
            this.isLoading = false;
          } else {
            this.messageDialogOpen = true;
            this.dialogText =
              "Non è stato possibile recuperare i dati degli ordini!";
          }
        })
        .catch((e) => {
          console.warn(e);
          this.messageDialogOpen = true;
          this.dialogText =
            "Non è stato possibile recuperare i dati degli ordini!";
        });
      // reset search field
      this.search = "";
    } else {
      // CASE USER --- USER'S ORDERS
      customerOrderService
        .getOrdersByCustomer(
          this.userName,
          this.dateStart,
          this.dateEnd,
          this.orderID ? this.orderID : "",
          this.checkNotCompleted,
          this.checkNoEmail
        )
        .then((res) => {
          // Open state dialog
          if (res.status === 200) {
            this.set = res.data;
            this.isLoading = false;
          } else {
            this.messageDialogOpen = true;
            this.dialogText =
              "Non è stato possibile recuperare i dati degli ordini!";
          }
        })
        .catch((e) => {
          console.warn(e);
          this.messageDialogOpen = true;
          this.dialogText =
            "Non è stato possibile recuperare i dati degli ordini!";
        });
      // reset search field
      this.search = "";
    }
  }

  // METHODS --- SEND EMAIL ACTIONS
  private openEmailDialog(itemSelected): void {
    if (this.adminUsers.includes(this.userName)) {
      this.emailItemToSend = itemSelected;
      this.dialogEmail = true;
    }
  }

  private confirmEmailDialog(): void {
    this.isLoadingButton = true;
    customerOrderService
      .sendEmail(
        this.emailItemToSend.orderID,
        this.emailItemToSend.codiceCliente
      )
      .then((res) => {
        this.loadingOverlayOpen = false;
        if (res.status === 200) {
          this.dialogEmail = false;
          this.messageDialogOpen = true;
          this.isLoadingButton = false;
          this.dialogText = "Email inviata correttamente.";
        } else {
          errorHandling();
        }
      })
      .catch((e) => {
        console.warn(e);
        errorHandling();
      });

    let errorHandling = (): void => {
      this.messageDialogOpen = true;
      this.dialogText = "Non è stato possibile inviare l'email!";
      this.isLoadingButton = false;
    };
  }

  // METHODS --- ORDER DETAILS MODAL
  private viewOrderDetails(orderItem): void {
    this.loadingOverlayOpen = true;
    // overlayModule.showOverlay();
    this.selectedOrder.orderId = orderItem.orderID;
    this.selectedOrder.orderDate = orderItem.orderDate
      .split("T")[1]
      .split(".")[0];
    this.selectedOrder.purchaseDateView = orderItem.purchaseDateView;
    this.selectedOrder.codiceCliente = orderItem.codiceCliente;
    this.selectedOrder.ragioneSociale = orderItem.ragioneSociale;

    customerOrderService
      .getOrderKitsByID(orderItem.orderID)
      .then((resKits) => {
        this.selectedOrderKits = resKits.data;
        customerOrderService
          .getOrderByID(orderItem.orderID)
          .then((res) => {
            this.loadingOverlayOpen = false;
            if (res.status === 200) {
              this.simpleTableKey = !this.simpleTableKey;
              // overlayModule.hideOverlay();
              this.selectedOrder.OrderDetails = res.data;
              // ELAB MAX
              this.selectedOrderAmount = resKits.data * 14; // add numKits
              res.data.forEach((dataItem: any) => {
                this.selectedOrderAmount += dataItem.price * dataItem.quantity;
              });
              this.isLoading = false;
              this.dialogDetails = true;
            } else {
              errorHandling();
            }
          })
          .catch((e) => {
            console.warn(e);
            errorHandling();
          });
      })
      .catch((e) => {
        console.warn(e);
        errorHandling();
      });

    let errorHandling = (): void => {
      this.loadingOverlayOpen = false;
      this.messageDialogOpen = true;
      this.dialogText = "Non è stato possibile recuperare i dati degli ordini!";
      // overlayModule.hideOverlay();
    };
  }

  // METHODS --- PRINT DETAILS ACTION
  private exportDetails(): void {
    this.isLoadingButton = true;
    customerOrderService
      .exportCustomerOrder(
        this.selectedOrder.orderId,
        this.selectedOrder.codiceCliente,
        this.selectedOrder.orderDate,
        this.selectedOrder.ragioneSociale
      )
      .then((res) => {
        if (res.status === 200) {
          if (res.data.isSuccess) {
            let downloadLinkEl = document.createElement("a");
            downloadLinkEl.href = res.data.result;
            downloadLinkEl.download = `ordine${this.selectedOrder.orderId}`;
            downloadLinkEl.click();
            downloadLinkEl.remove();
            this.isLoadingButton = false;
            this.dialogDetails = false;
          } else {
            errorHandling();
          }
        } else {
          errorHandling();
        }
      })
      .catch((e) => {
        console.warn(e);
        errorHandling();
      });

    let errorHandling = (): void => {
      this.isLoadingButton = false;
      this.messageDialogOpen = true;
      this.dialogText =
        "Non è stato possibile esportare i dati dell'ordine come PDF!";
    };
  }
}
